import { FC, useCallback } from 'react';
import { useBooking, useDialog, useRouteHandler } from '@/logic/state';

import shallow from 'zustand/shallow';
import { useRouter } from 'next/router';
import { InfoDialog } from '@/components/shared/info-dialog';

export const SessionExpiredInfoDialog: FC = () => {
  const router = useRouter();
  const [dialog, setDialog] = useDialog(s => [s.dialog, s.setDialog], shallow);
  const booking = useBooking(s => s.booking, shallow);
  const routeHandler = useRouteHandler(s => s.routeHandler, shallow);

  const handleOkayClick = useCallback(() => {
    routeHandler?.removeOnRouteChangeStartListener?.();
    setDialog({});
    router.push(
      `/movies/${dialog?.sessionExpiredInfoDialogPayload?.slug}/?cityId=${booking?.cityId}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    booking?.cityId,
    dialog?.sessionExpiredInfoDialogPayload?.slug,
    routeHandler?.removeOnRouteChangeStartListener,
    router,
    setDialog,
  ]);

  return (
    <InfoDialog
      buttonId='session-expired-info-dialog'
      img='/icons/booking/session-expired-icon.svg'
      title='booking.session_expired_info_dialog.title'
      description='booking.session_expired_info_dialog.description'
      handleOkayClick={handleOkayClick}
    />
  );
};
